import { createSlice } from "@reduxjs/toolkit";
import {
	getSubscription_,
	setSubscription_,
	emptySubscription_,
} from "../../lib/useLocalStorageUser";

const subscriptionInfo = getSubscription_();

const subscriptionSlice = createSlice({
	name: "subscription",
	initialState: subscriptionInfo ? subscriptionInfo : null,
	reducers: {
		getSubscription(state, action) {
			return getSubscription_();
		},
		setSubscription(state, action) {
			const subscriptionData = { ...state, ...action.payload };
			setSubscription_(subscriptionData);
			return subscriptionData;
		},
		removeSubscription() {
			emptySubscription_();
			return null;
		},
	},
});

export const {
	getSubscription,
	setSubscription,
	removeSubscription,
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
